import { useQuery } from '@tanstack/react-query';

import { organisationsQueries } from '../../queries/organisations';
import { GetValuesParams } from '../../types/dto';

import { useQueriesWithGlobal } from '@data-access';

interface useValuesProps {
  params: GetValuesParams;
}

export function useValues({ params }: useValuesProps) {
  const valuesParams: GetValuesParams = {};
  if (params.role) {
    valuesParams.role = params.role;
  }
  if (params.org) {
    valuesParams.org = params.org;
  }
  const queries = useQueriesWithGlobal(organisationsQueries);
  const query = useQuery(queries.values(valuesParams));

  return query;
}

export default useValues;
